import { deleteRequest, getRequest, postRequest, putRequest } from "../utils/api";

//-------------------------- Dashboard Customization Services - START -----------------------------//
export const getDeviceParameters = async (systemId) => { 
    const response = await getRequest(`/Dashboard/deviceparameters?systemId=${systemId}`);
    const options = response?.data?.parameters?.map(param => ({
        label: param.name,
        value: param.id
    }));
    return options;
  };
  
  export const createConfiguration = async (settingsInfo) => { 
    const response = await postRequest(`/Dashboard/configuration`, settingsInfo);
    return response;
  };
  
  export const getDashBoardGridData = async (systemId) => { 
    const response = await getRequest(`/Dashboard/configurationlist/${systemId}`);
    return response;
  };
  
  export const deleteConfig = async (configurationId) => {
    const response = await deleteRequest(`/Dashboard/configuration?configurationId=${configurationId}`);
    return response;
  };
  
  export const getConfigInfo = async (configurationId) => {
    const response = await getRequest(`/Dashboard/configuration/${configurationId}`);
    return response;
  };

export const updateConfigurationInfo = async (configurationId, payload) => {
  const response = await putRequest(`/Dashboard/configuration?configurationId=${configurationId}`, payload);
  return response;
};

//---------------------------- Dashboard Customization Services - END ----------------------------//
  

//-----------------------------------Dashboard Services - START-----------------------------------//

// Get dashboard details for status and cards
export const getDashboardDetails = async (systemId) => {
  const response = await getRequest(`/Dashboard/alarmstatuswithcards/${systemId}`);
  return response;
};

// Get parameter logs with respect to parameterId, for Chart in modal
export const getParameterLogs = async (parameterId, systemId) => {
  const response = await getRequest(`/Dashboard/parameterLogs/systemId/parameterId?systemId=${systemId}&parameterId=${parameterId}`);
  return response;
};

// Get parameter details for charts
export const getChartData = async (systemId) => {
  const response = await getRequest(`/Dashboard/charts/${systemId}`);
  return response;
};

// Get parameter details for Grid
export const getDashboardData = async (parameterIds) => {
  const payload = {
    selectedParameterIds: parameterIds
  };
  const response = await postRequest('/Dashboard/GridData', payload);
  return response;
};

//Get all image parameters for a system
export const getImageData = async (systemId) => {
  const response = await getRequest(`/Dashboard/imagedata/${systemId}`);
  return response;
};

//-----------------------------------Dashboard Services - END -----------------------------------//


//----------------------------------- Image Parameters APIs - START --------------------------- //

export const getImageParameters = async (systemId) => { 
  const response = await getRequest(`/Dashboard/dashboardmanagement/${systemId}`);
  return response;
};

export const postImageParameters = async (imageData) => {
  const response = await postRequest(`/Dashboard/dashboardmanagement`, imageData);
  return response;
}

//------------------------------------ Image Parameters APIs - END --------------------------- //

